import React from 'react';

import { PropertySelect } from '../PropertySelect';

const PropertySelectField = ({
  readOnly,
  haveError,
  field,
  helpers,
  error,
  onChanged,
  ...restProps
}: {
  readOnly: any;
  haveError: any;
  field: any;
  helpers: any;
  error: any;
  onChanged: any;
} & Record<string, any>) => {
  const handleChange = (event: any) => {
    if (readOnly) {
      return;
    }

    field.onChange(event);

    if (onChanged) {
      onChanged(field.name, event.target.checked);
    }
  };

  return (
    <PropertySelect
      {...restProps}
      checked={field.checked}
      name={field.name}
      onChange={handleChange}
      onBlur={field.onBlur}
    />
  );
};

export default React.memo(PropertySelectField) as any;
